import { render, staticRenderFns } from "./operatingRecord.vue?vue&type=template&id=0e45e25a&scoped=true"
import script from "./operatingRecord.vue?vue&type=script&lang=js"
export * from "./operatingRecord.vue?vue&type=script&lang=js"
import style0 from "./operatingRecord.vue?vue&type=style&index=0&id=0e45e25a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e45e25a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e45e25a')) {
      api.createRecord('0e45e25a', component.options)
    } else {
      api.reload('0e45e25a', component.options)
    }
    module.hot.accept("./operatingRecord.vue?vue&type=template&id=0e45e25a&scoped=true", function () {
      api.rerender('0e45e25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/operatingRecord.vue"
export default component.exports